"use client";
import { COLORS as r } from "../../tokens/colors/Colors.js";
const n = (a, c, o = "info") => {
  let e;
  switch (o) {
    case "error":
      e = r.redBase;
      break;
    case "info":
      e = r.brand;
      break;
    case "warn":
      e = r.yellowDark;
      break;
    default:
      e = r.black;
      break;
  }
  return console[o](
    `%cFerris | ${a}:`,
    `color: ${e}; font-weight: bold`,
    `
${c}`
  );
};
export {
  n as feLog
};
